function ProjectCard({name, role, skill, problem, contributions, status, link, linkLabel}) {
    return (
        <div className="project-card">
            <div className="project-card-header">
                <h2 className="year-header">{name}</h2>
                <h3 className="detail-body project-role">{role}</h3>
            </div>
            <div className="chip-container">
                {skill.map((item) => (
                    <span key={item} className="chip-item">{item}</span>
                ))}
            </div>
            <h3 className="name-body">{problem}</h3>
            <ul className="project-bullets">
                {contributions.map((item) => (
                    <li key={item} className="detail-body">{item}</li>
                ))}
            </ul>
            <div className="project-footer">
                <span className="project-status">{status}</span>
                {link && <a className="project-link" href={link} target="_blank" rel="noopener noreferrer">{linkLabel}</a>}
            </div>
            <br />
        </div>
    )
}

export default ProjectCard
